// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Services/AppModernization/ellipse.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/Services/AppModernization/section-7.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-mod-section-1 {
    display: flex;
    color: #20303F;
    width: 80%;
    margin: auto;
    margin-bottom: var(--margin-bottom-web);
    margin-top: 250px;
}

.app-mod-section-1-left p:nth-child(1) {
    margin: 0;
    font-size: var(--font-size1);
    font-weight: bold;
}

.app-mod-section-1-left p:nth-child(2) {
    font-size: var(--font-size2);
    font-weight: lighter;
    margin: 0;
}

.app-mod-section-1-left p:nth-child(3) {
    margin: 0;
    font-size: var(--font-size2);
    font-weight: bolder;
    margin: 0;
}

.app-mod-section-1-right {
    & img {
        width: 100%;
    }
}

.app-mod-section-3 {
    display: flex;
    margin: auto;
    width: 80%;
    justify-content: center;
}

.app-mod-section-3-left {
    width: 40%;
}

.app-mod-section-3-right {
    width: 50%;

    & img {
        width: 100%;
    }
}

.app-mod-section-3-left p:nth-child(1) {
    font-size: var(--font-size3);
    margin: 0;
    font-weight: lighter;
}

.app-mod-section-3-left p:nth-child(2) {
    font-size: var(--font-size3);
    margin: 0;
    color: #20303F;
    font-weight: bold;
}

.app-mod-section-3-left p:nth-child(3) {
    font-size: var(--font-size3);
    margin: 0;
    color: #0B63E5;
    font-weight: bold;
}

.app-mod-section-3-left p:nth-child(4) {
    font-size: var(--font-size4);
    width: 70%;
}

.app-mod-section-4 {
    width: 100%;
    padding-top: 10rem;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: center;
    margin-bottom: var(--margin-bottom-web);
}

.app-mod-section-4>div {
    width: 80%;
    margin: auto;
}

.app-mod-section-4-top {
    text-align: center;
    margin-bottom: 5rem;

    & p {
        margin: 0;
    }
}

.app-mod-section-4-top p:nth-child(1),
.app-mod-section-4-top p:nth-child(2) {
    font-size: var(--font-size5);
}

.app-mod-section-4-top p:nth-child(2) {
    font-weight: bold;
}

.app-mod-section-4-top p:nth-child(3) {
    font-size: var(--font-size4);
}

.app-mod-section-4-bottom {
    display: flex;
    justify-content: space-between;

    & div {
        width: 28%;
        border-radius: 1rem;
        box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
        padding: 3rem 1rem 1.5rem;
        background-color: white;
    }
}

.app-mod-section-4-bottom div p:nth-child(2) {
    font-size: var(--font-size6);
    font-weight: bold;
    color: #292962
}

.app-mod-section-4-bottom div p:nth-child(3) {
    font-size: var(--font-size7);
    width: 80%;
    color: #6B7989;
}

/* section number5 */
.app-mod-section-5 {
    margin-bottom: -400px;
}

.app-mod-section-5-One>:nth-child(1) {
    /* background-color: yellow; */
    font-size: 36px;
    font-weight: 200;
    line-height: 48px;
    text-align: center;
    margin-bottom: 0px;
}

.app-mod-section-5-One>:nth-child(2) {
    margin-top: 0px;
    font-size: 36px;
    font-weight: 800;
    line-height: 48px;
    text-align: center;
}

.app-mod-section-5-One>:nth-child(3) {
    margin-top: 12px;
    font-size: 20px;
    font-weight: 400;
    line-height: 30.66px;
    text-align: center;
}

@media screen and (max-width:1280px) {
    .app-mod-section-5 {
        margin-bottom: 100px;
    }

    .app-mod-section-1 {
        display: flex;
        color: #20303F;
        width: 80%;
        margin: auto;
        margin-bottom: var(--margin-bottom-web);
        margin-top: 0x;
    }
}

@media screen and (max-width:1450px) {
    .app-mod-section-5 {
        margin-top: 100px;
    }
}

.app-mod-section-5-One>:nth-child(1) {
    font-size: 36px;
    font-weight: 200;
    line-height: 48px;
    text-align: center;
    margin-bottom: 0px;
}

.app-mod-section-5-One>:nth-child(2) {
    margin-top: 0px;
    font-size: 36px;
    font-weight: 800;
    line-height: 48px;
    text-align: center;
}

.app-mod-section-5-One>:nth-child(3) {
    margin-top: 12px;
    font-size: 20px;
    font-weight: 400;
    line-height: 30.66px;
    text-align: center;
}

@media screen and (max-width:1280px) {
    .app-mod-section-5 {
        margin-bottom: 100px;
    }
}

.app-mod-section-6 {
    width: 80%;
    margin: auto;
    margin-top: -500px;
    margin-bottom: var(--margin-bottom-web);
}

.app-mod-section-6-top {
    width: 55%;
    font-size: var(--font-size5);
    margin-bottom: 5rem;

    & p {
        margin: 0;
    }
}

.app-mod-section-6-top p:nth-child(1) {
    font-weight: lighter;
}

.app-mod-section-6-top p:nth-child(2) {
    font-weight: bold;
}

.app-mod-section-6-bottom {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 4rem;

    & div {
        box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;
        padding: 3rem 1rem 1.5rem;
        border-radius: 1rem;
    }
}

.app-mod-section-6-bottom>div p:nth-child(2) {
    font-size: var(--font-size6);
    font-weight: bold;
    color: #292962
}

.app-mod-section-6-bottom>div p:nth-child(3) {
    font-size: var(--font-size7);
    color: #6B7989;
}

.app-mod-section-7 {
    width: 100%;
    margin: auto;
    margin-bottom: var(--margin-bottom-web);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-position: center;
    background-size: cover;
}

.app-mod-section-7>div {
    width: 30%;
    font-size: var(--font-size6);
    margin-left: 10%;
    padding: 1%;

    & p:nth-child(3) {
        font-weight: bold;
    }
}

.app-mod-section-8 {
    width: 80%;
    margin: auto;
    margin-bottom: var(--margin-bottom-web);
}

.app-mod-section-8-top {
    font-size: var(--font-size5);
    margin-bottom: 3rem;

    & p {
        margin: 0;
    }

    & p:nth-child(2) {
        font-weight: bold;
    }
}

.app-mod-section-8-bottom {
    display: flex;
    justify-content: space-between;

    & div {
        width: 28%;
        background-color: #0B63E5;
        color: white;
        padding: 1%;
        border-radius: 1rem;

        & img {
            width: 100%;
            aspect-ratio: 16/9;
            border-radius: 1rem;
        }

        & p {
            font-size: 28px;
        }

        & ul {
            font-size: 18px;
            font-weight: lighter;
            width: 80%;
        }
    }
}

.app-mod-section-9 {
    font-size: var(--font-size3);
    width: 90%;
    margin: auto;
    margin-bottom: var(--margin-bottom-web);
    text-align: center;
    font-weight: lighter;

    @media screen and (max-width:1280px) {
        font-size: 2.25rem;
    }
}


@media screen and (min-width:300px) and (max-width:490px) {
    .app-mod-section-1 {
        flex-direction: column;
        margin-top: 0px;
        margin-bottom: var(--margin-bottom-mobile);
    }

    .app-mod-section-1-left p:nth-child(1) {
        font-size: 21px;
    }

    .app-mod-section-1-left p:nth-child(2) {
        font-size: 41px;
    }

    .app-mod-section-1-left p:nth-child(3) {
        font-size: 41px;
    }

    .app-mod-section-3 {
        flex-direction: column;
        width: 90%;
        margin-bottom: var(--margin-bottom-mobile);
    }

    .app-mod-section-3-left,
    .app-mod-section-3-right {
        width: 100%;
    }

    .app-mod-section-3-left p:nth-child(1),
    .app-mod-section-3-left p:nth-child(2),
    .app-mod-section-3-left p:nth-child(3) {
        font-size: 41px;
    }

    .app-mod-section-3-left p:nth-child(4) {
        font-size: 1rem;
        width: 80%;
    }

    .app-mod-section-4 {
        margin-bottom: var(--margin-bottom-mobile);
        padding: 1rem 0;
    }

    .app-mod-section-4>div {
        width: 90%;
    }

    .app-mod-section-4-bottom {
        flex-direction: column;
        gap: 1rem;

        & div {
            width: 85%;
            margin: auto;
        }
    }

    .app-mod-section-4-bottom div p:nth-child(2) {
        font-size: var(--font-size4);
    }

    .app-mod-section-6 {
        width: 90%;
        margin-top: 0;
        margin-bottom: var(--margin-bottom-mobile);
    }

    .app-mod-section-6-top {
        width: 100%;
        font-size: 2rem;
    }

    .app-mod-section-6-bottom {
        grid-template-columns: repeat(1, 1fr);
        gap: 1rem;
    }

    .app-mod-section-6-bottom>div p:nth-child(2) {
        font-size: var(--font-size4);
    }

    .app-mod-section-7 {
        width: 90%;
        margin-bottom: var(--margin-bottom-mobile);
    }


    .app-mod-section-7>div {
        width: 90%;
        font-size: 18px;
    }

    .app-mod-section-8 {
        width: 90%;
        margin-bottom: var(--margin-bottom-mobile);
    }

    .app-mod-section-8-bottom {
        flex-direction: column;
        gap: 1rem;

        & div {
            width: 90%;
            margin: auto;
            padding: 2%;
        }
    }

    .app-mod-section-9 {
        font-size: 1.2rem;
        width: 90%;
        margin-bottom: var(--margin-bottom-mobile);
    }

    section {
        margin-bottom: var(--margin-bottom-mobile);
    }
}

@media screen and (min-width:601px) and (max-width:840px) {

    .app-mod-section-1-left p:nth-child(2),
    .app-mod-section-1-left p:nth-child(3) {
        font-size: 45px;
    }

    .app-mod-section-1-right {
        & img {
            width: 100%;
        }
    }

    .app-mod-section-3 {
        flex-direction: column;
        width: 100%;
    }

    .app-mod-section-3-left {
        width: 80%;
        margin: auto;
    }

    .app-mod-section-3-right {
        width: 90%;
        margin: auto;

        & img {
            width: 100%;
        }
    }

    .app-mod-section-3-left p:nth-child(1),
    .app-mod-section-3-left p:nth-child(2),
    .app-mod-section-3-left p:nth-child(3) {
        font-size: 45px;
        text-align: center;
    }

    .app-mod-section-3-left p:nth-child(4) {
        width: 90%;
        margin: auto;
        font-size: 30px;
        margin-bottom: 2rem;
    }

    .app-mod-section-4-bottom {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 1rem;

        & div {
            width: 80%;
            margin: auto;
        }
    }

    .app-mod-section-6 {
        width: 90%;
        margin-top: 0;
    }

    .app-mod-section-6-top {
        width: 90%;
    }

    .app-mod-section-6-bottom {
        grid-template-columns: repeat(2, 1fr);
    }

    .app-mod-section-7>div {
        width: 70%;
    }

    .app-mod-section-8 {
        width: 90%;
    }

    .app-mod-section-8-bottom {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 2rem;

        & div {
            width: 80%;
            margin: auto;

            & img {
                width: 100%;
            }
        }
    }
}

@media screen and (min-width:841px) and (max-width:1450px) {

    .app-mod-section-1-left p:nth-child(2),
    .app-mod-section-1-left p:nth-child(3) {
        font-size: 51px;
    }

    .app-mod-section-1-right {
        & img {
            width: 80%;
        }
    }

    .app-mod-section-3 {
        width: 80%;
    }

    .app-mod-section-3-left {
        width: 70%;
    }

    .app-mod-section-3-right {
        width: 45%;
        display: flex;
        align-items: center;

        & img {
            width: 100%;
        }
    }

    .app-mod-section-4 {
        margin-bottom: var(--margin-bottom-mobile);
        padding: 1rem 0;
    }

    .app-mod-section-8-bottom {

        & p {
            font-size: 22px;
        }

        & ul {
            font-size: 10px;
        }
    }

    .app-mod-section-9 {
        width: 90%;
        font-size: 2rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Services/AppModernization.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,cAAc;IACd,UAAU;IACV,YAAY;IACZ,uCAAuC;IACvC,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,4BAA4B;IAC5B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;;IAEV;QACI,WAAW;IACf;AACJ;;AAEA;IACI,4BAA4B;IAC5B,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,4BAA4B;IAC5B,SAAS;IACT,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;IAC5B,SAAS;IACT,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;IAC5B,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yDAA2E;IAC3E,4BAA4B;IAC5B,2BAA2B;IAC3B,uCAAuC;AAC3C;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;;IAEnB;QACI,SAAS;IACb;AACJ;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,8BAA8B;;IAE9B;QACI,UAAU;QACV,mBAAmB;QACnB,iDAAiD;QACjD,yBAAyB;QACzB,uBAAuB;IAC3B;AACJ;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB;AACJ;;AAEA;IACI,4BAA4B;IAC5B,UAAU;IACV,cAAc;AAClB;;AAEA,oBAAoB;AACpB;IACI,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,aAAa;QACb,cAAc;QACd,UAAU;QACV,YAAY;QACZ,uCAAuC;QACvC,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA;IACI,UAAU;IACV,4BAA4B;IAC5B,mBAAmB;;IAEnB;QACI,SAAS;IACb;AACJ;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;;IAET;QACI,8CAA8C;QAC9C,yBAAyB;QACzB,mBAAmB;IACvB;AACJ;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB;AACJ;;AAEA;IACI,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC,yDAA6E;IAC7E,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,4BAA4B;IAC5B,gBAAgB;IAChB,WAAW;;IAEX;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;IAC5B,mBAAmB;;IAEnB;QACI,SAAS;IACb;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;;IAE9B;QACI,UAAU;QACV,yBAAyB;QACzB,YAAY;QACZ,WAAW;QACX,mBAAmB;;QAEnB;YACI,WAAW;YACX,kBAAkB;YAClB,mBAAmB;QACvB;;QAEA;YACI,eAAe;QACnB;;QAEA;YACI,eAAe;YACf,oBAAoB;YACpB,UAAU;QACd;IACJ;AACJ;;AAEA;IACI,4BAA4B;IAC5B,UAAU;IACV,YAAY;IACZ,uCAAuC;IACvC,kBAAkB;IAClB,oBAAoB;;IAEpB;QACI,kBAAkB;IACtB;AACJ;;;AAGA;IACI;QACI,sBAAsB;QACtB,eAAe;QACf,0CAA0C;IAC9C;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,UAAU;QACV,0CAA0C;IAC9C;;IAEA;;QAEI,WAAW;IACf;;IAEA;;;QAGI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,UAAU;IACd;;IAEA;QACI,0CAA0C;QAC1C,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,SAAS;;QAET;YACI,UAAU;YACV,YAAY;QAChB;IACJ;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,UAAU;QACV,aAAa;QACb,0CAA0C;IAC9C;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,qCAAqC;QACrC,SAAS;IACb;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,UAAU;QACV,0CAA0C;IAC9C;;;IAGA;QACI,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,0CAA0C;IAC9C;;IAEA;QACI,sBAAsB;QACtB,SAAS;;QAET;YACI,UAAU;YACV,YAAY;YACZ,WAAW;QACf;IACJ;;IAEA;QACI,iBAAiB;QACjB,UAAU;QACV,0CAA0C;IAC9C;;IAEA;QACI,0CAA0C;IAC9C;AACJ;;AAEA;;IAEI;;QAEI,eAAe;IACnB;;IAEA;QACI;YACI,WAAW;QACf;IACJ;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,YAAY;;QAEZ;YACI,WAAW;QACf;IACJ;;IAEA;;;QAGI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,qCAAqC;QACrC,SAAS;;QAET;YACI,UAAU;YACV,YAAY;QAChB;IACJ;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;QACb,qCAAqC;QACrC,SAAS;;QAET;YACI,UAAU;YACV,YAAY;;YAEZ;gBACI,WAAW;YACf;QACJ;IACJ;AACJ;;AAEA;;IAEI;;QAEI,eAAe;IACnB;;IAEA;QACI;YACI,UAAU;QACd;IACJ;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;QACV,aAAa;QACb,mBAAmB;;QAEnB;YACI,WAAW;QACf;IACJ;;IAEA;QACI,0CAA0C;QAC1C,eAAe;IACnB;;IAEA;;QAEI;YACI,eAAe;QACnB;;QAEA;YACI,eAAe;QACnB;IACJ;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;AACJ","sourcesContent":[".app-mod-section-1 {\r\n    display: flex;\r\n    color: #20303F;\r\n    width: 80%;\r\n    margin: auto;\r\n    margin-bottom: var(--margin-bottom-web);\r\n    margin-top: 250px;\r\n}\r\n\r\n.app-mod-section-1-left p:nth-child(1) {\r\n    margin: 0;\r\n    font-size: var(--font-size1);\r\n    font-weight: bold;\r\n}\r\n\r\n.app-mod-section-1-left p:nth-child(2) {\r\n    font-size: var(--font-size2);\r\n    font-weight: lighter;\r\n    margin: 0;\r\n}\r\n\r\n.app-mod-section-1-left p:nth-child(3) {\r\n    margin: 0;\r\n    font-size: var(--font-size2);\r\n    font-weight: bolder;\r\n    margin: 0;\r\n}\r\n\r\n.app-mod-section-1-right {\r\n    & img {\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n.app-mod-section-3 {\r\n    display: flex;\r\n    margin: auto;\r\n    width: 80%;\r\n    justify-content: center;\r\n}\r\n\r\n.app-mod-section-3-left {\r\n    width: 40%;\r\n}\r\n\r\n.app-mod-section-3-right {\r\n    width: 50%;\r\n\r\n    & img {\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n.app-mod-section-3-left p:nth-child(1) {\r\n    font-size: var(--font-size3);\r\n    margin: 0;\r\n    font-weight: lighter;\r\n}\r\n\r\n.app-mod-section-3-left p:nth-child(2) {\r\n    font-size: var(--font-size3);\r\n    margin: 0;\r\n    color: #20303F;\r\n    font-weight: bold;\r\n}\r\n\r\n.app-mod-section-3-left p:nth-child(3) {\r\n    font-size: var(--font-size3);\r\n    margin: 0;\r\n    color: #0B63E5;\r\n    font-weight: bold;\r\n}\r\n\r\n.app-mod-section-3-left p:nth-child(4) {\r\n    font-size: var(--font-size4);\r\n    width: 70%;\r\n}\r\n\r\n.app-mod-section-4 {\r\n    width: 100%;\r\n    padding-top: 10rem;\r\n    background-image: url('../../assets/Services/AppModernization/ellipse.png');\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n    margin-bottom: var(--margin-bottom-web);\r\n}\r\n\r\n.app-mod-section-4>div {\r\n    width: 80%;\r\n    margin: auto;\r\n}\r\n\r\n.app-mod-section-4-top {\r\n    text-align: center;\r\n    margin-bottom: 5rem;\r\n\r\n    & p {\r\n        margin: 0;\r\n    }\r\n}\r\n\r\n.app-mod-section-4-top p:nth-child(1),\r\n.app-mod-section-4-top p:nth-child(2) {\r\n    font-size: var(--font-size5);\r\n}\r\n\r\n.app-mod-section-4-top p:nth-child(2) {\r\n    font-weight: bold;\r\n}\r\n\r\n.app-mod-section-4-top p:nth-child(3) {\r\n    font-size: var(--font-size4);\r\n}\r\n\r\n.app-mod-section-4-bottom {\r\n    display: flex;\r\n    justify-content: space-between;\r\n\r\n    & div {\r\n        width: 28%;\r\n        border-radius: 1rem;\r\n        box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\r\n        padding: 3rem 1rem 1.5rem;\r\n        background-color: white;\r\n    }\r\n}\r\n\r\n.app-mod-section-4-bottom div p:nth-child(2) {\r\n    font-size: var(--font-size6);\r\n    font-weight: bold;\r\n    color: #292962\r\n}\r\n\r\n.app-mod-section-4-bottom div p:nth-child(3) {\r\n    font-size: var(--font-size7);\r\n    width: 80%;\r\n    color: #6B7989;\r\n}\r\n\r\n/* section number5 */\r\n.app-mod-section-5 {\r\n    margin-bottom: -400px;\r\n}\r\n\r\n.app-mod-section-5-One>:nth-child(1) {\r\n    /* background-color: yellow; */\r\n    font-size: 36px;\r\n    font-weight: 200;\r\n    line-height: 48px;\r\n    text-align: center;\r\n    margin-bottom: 0px;\r\n}\r\n\r\n.app-mod-section-5-One>:nth-child(2) {\r\n    margin-top: 0px;\r\n    font-size: 36px;\r\n    font-weight: 800;\r\n    line-height: 48px;\r\n    text-align: center;\r\n}\r\n\r\n.app-mod-section-5-One>:nth-child(3) {\r\n    margin-top: 12px;\r\n    font-size: 20px;\r\n    font-weight: 400;\r\n    line-height: 30.66px;\r\n    text-align: center;\r\n}\r\n\r\n@media screen and (max-width:1280px) {\r\n    .app-mod-section-5 {\r\n        margin-bottom: 100px;\r\n    }\r\n\r\n    .app-mod-section-1 {\r\n        display: flex;\r\n        color: #20303F;\r\n        width: 80%;\r\n        margin: auto;\r\n        margin-bottom: var(--margin-bottom-web);\r\n        margin-top: 0x;\r\n    }\r\n}\r\n\r\n@media screen and (max-width:1450px) {\r\n    .app-mod-section-5 {\r\n        margin-top: 100px;\r\n    }\r\n}\r\n\r\n.app-mod-section-5-One>:nth-child(1) {\r\n    font-size: 36px;\r\n    font-weight: 200;\r\n    line-height: 48px;\r\n    text-align: center;\r\n    margin-bottom: 0px;\r\n}\r\n\r\n.app-mod-section-5-One>:nth-child(2) {\r\n    margin-top: 0px;\r\n    font-size: 36px;\r\n    font-weight: 800;\r\n    line-height: 48px;\r\n    text-align: center;\r\n}\r\n\r\n.app-mod-section-5-One>:nth-child(3) {\r\n    margin-top: 12px;\r\n    font-size: 20px;\r\n    font-weight: 400;\r\n    line-height: 30.66px;\r\n    text-align: center;\r\n}\r\n\r\n@media screen and (max-width:1280px) {\r\n    .app-mod-section-5 {\r\n        margin-bottom: 100px;\r\n    }\r\n}\r\n\r\n.app-mod-section-6 {\r\n    width: 80%;\r\n    margin: auto;\r\n    margin-top: -500px;\r\n    margin-bottom: var(--margin-bottom-web);\r\n}\r\n\r\n.app-mod-section-6-top {\r\n    width: 55%;\r\n    font-size: var(--font-size5);\r\n    margin-bottom: 5rem;\r\n\r\n    & p {\r\n        margin: 0;\r\n    }\r\n}\r\n\r\n.app-mod-section-6-top p:nth-child(1) {\r\n    font-weight: lighter;\r\n}\r\n\r\n.app-mod-section-6-top p:nth-child(2) {\r\n    font-weight: bold;\r\n}\r\n\r\n.app-mod-section-6-bottom {\r\n    display: grid;\r\n    grid-template-columns: repeat(3, 1fr);\r\n    gap: 4rem;\r\n\r\n    & div {\r\n        box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;\r\n        padding: 3rem 1rem 1.5rem;\r\n        border-radius: 1rem;\r\n    }\r\n}\r\n\r\n.app-mod-section-6-bottom>div p:nth-child(2) {\r\n    font-size: var(--font-size6);\r\n    font-weight: bold;\r\n    color: #292962\r\n}\r\n\r\n.app-mod-section-6-bottom>div p:nth-child(3) {\r\n    font-size: var(--font-size7);\r\n    color: #6B7989;\r\n}\r\n\r\n.app-mod-section-7 {\r\n    width: 100%;\r\n    margin: auto;\r\n    margin-bottom: var(--margin-bottom-web);\r\n    background-image: url('../../assets/Services/AppModernization/section-7.png');\r\n    background-position: center;\r\n    background-size: cover;\r\n}\r\n\r\n.app-mod-section-7>div {\r\n    width: 30%;\r\n    font-size: var(--font-size6);\r\n    margin-left: 10%;\r\n    padding: 1%;\r\n\r\n    & p:nth-child(3) {\r\n        font-weight: bold;\r\n    }\r\n}\r\n\r\n.app-mod-section-8 {\r\n    width: 80%;\r\n    margin: auto;\r\n    margin-bottom: var(--margin-bottom-web);\r\n}\r\n\r\n.app-mod-section-8-top {\r\n    font-size: var(--font-size5);\r\n    margin-bottom: 3rem;\r\n\r\n    & p {\r\n        margin: 0;\r\n    }\r\n\r\n    & p:nth-child(2) {\r\n        font-weight: bold;\r\n    }\r\n}\r\n\r\n.app-mod-section-8-bottom {\r\n    display: flex;\r\n    justify-content: space-between;\r\n\r\n    & div {\r\n        width: 28%;\r\n        background-color: #0B63E5;\r\n        color: white;\r\n        padding: 1%;\r\n        border-radius: 1rem;\r\n\r\n        & img {\r\n            width: 100%;\r\n            aspect-ratio: 16/9;\r\n            border-radius: 1rem;\r\n        }\r\n\r\n        & p {\r\n            font-size: 28px;\r\n        }\r\n\r\n        & ul {\r\n            font-size: 18px;\r\n            font-weight: lighter;\r\n            width: 80%;\r\n        }\r\n    }\r\n}\r\n\r\n.app-mod-section-9 {\r\n    font-size: var(--font-size3);\r\n    width: 90%;\r\n    margin: auto;\r\n    margin-bottom: var(--margin-bottom-web);\r\n    text-align: center;\r\n    font-weight: lighter;\r\n\r\n    @media screen and (max-width:1280px) {\r\n        font-size: 2.25rem;\r\n    }\r\n}\r\n\r\n\r\n@media screen and (min-width:300px) and (max-width:490px) {\r\n    .app-mod-section-1 {\r\n        flex-direction: column;\r\n        margin-top: 0px;\r\n        margin-bottom: var(--margin-bottom-mobile);\r\n    }\r\n\r\n    .app-mod-section-1-left p:nth-child(1) {\r\n        font-size: 21px;\r\n    }\r\n\r\n    .app-mod-section-1-left p:nth-child(2) {\r\n        font-size: 41px;\r\n    }\r\n\r\n    .app-mod-section-1-left p:nth-child(3) {\r\n        font-size: 41px;\r\n    }\r\n\r\n    .app-mod-section-3 {\r\n        flex-direction: column;\r\n        width: 90%;\r\n        margin-bottom: var(--margin-bottom-mobile);\r\n    }\r\n\r\n    .app-mod-section-3-left,\r\n    .app-mod-section-3-right {\r\n        width: 100%;\r\n    }\r\n\r\n    .app-mod-section-3-left p:nth-child(1),\r\n    .app-mod-section-3-left p:nth-child(2),\r\n    .app-mod-section-3-left p:nth-child(3) {\r\n        font-size: 41px;\r\n    }\r\n\r\n    .app-mod-section-3-left p:nth-child(4) {\r\n        font-size: 1rem;\r\n        width: 80%;\r\n    }\r\n\r\n    .app-mod-section-4 {\r\n        margin-bottom: var(--margin-bottom-mobile);\r\n        padding: 1rem 0;\r\n    }\r\n\r\n    .app-mod-section-4>div {\r\n        width: 90%;\r\n    }\r\n\r\n    .app-mod-section-4-bottom {\r\n        flex-direction: column;\r\n        gap: 1rem;\r\n\r\n        & div {\r\n            width: 85%;\r\n            margin: auto;\r\n        }\r\n    }\r\n\r\n    .app-mod-section-4-bottom div p:nth-child(2) {\r\n        font-size: var(--font-size4);\r\n    }\r\n\r\n    .app-mod-section-6 {\r\n        width: 90%;\r\n        margin-top: 0;\r\n        margin-bottom: var(--margin-bottom-mobile);\r\n    }\r\n\r\n    .app-mod-section-6-top {\r\n        width: 100%;\r\n        font-size: 2rem;\r\n    }\r\n\r\n    .app-mod-section-6-bottom {\r\n        grid-template-columns: repeat(1, 1fr);\r\n        gap: 1rem;\r\n    }\r\n\r\n    .app-mod-section-6-bottom>div p:nth-child(2) {\r\n        font-size: var(--font-size4);\r\n    }\r\n\r\n    .app-mod-section-7 {\r\n        width: 90%;\r\n        margin-bottom: var(--margin-bottom-mobile);\r\n    }\r\n\r\n\r\n    .app-mod-section-7>div {\r\n        width: 90%;\r\n        font-size: 18px;\r\n    }\r\n\r\n    .app-mod-section-8 {\r\n        width: 90%;\r\n        margin-bottom: var(--margin-bottom-mobile);\r\n    }\r\n\r\n    .app-mod-section-8-bottom {\r\n        flex-direction: column;\r\n        gap: 1rem;\r\n\r\n        & div {\r\n            width: 90%;\r\n            margin: auto;\r\n            padding: 2%;\r\n        }\r\n    }\r\n\r\n    .app-mod-section-9 {\r\n        font-size: 1.2rem;\r\n        width: 90%;\r\n        margin-bottom: var(--margin-bottom-mobile);\r\n    }\r\n\r\n    section {\r\n        margin-bottom: var(--margin-bottom-mobile);\r\n    }\r\n}\r\n\r\n@media screen and (min-width:601px) and (max-width:840px) {\r\n\r\n    .app-mod-section-1-left p:nth-child(2),\r\n    .app-mod-section-1-left p:nth-child(3) {\r\n        font-size: 45px;\r\n    }\r\n\r\n    .app-mod-section-1-right {\r\n        & img {\r\n            width: 100%;\r\n        }\r\n    }\r\n\r\n    .app-mod-section-3 {\r\n        flex-direction: column;\r\n        width: 100%;\r\n    }\r\n\r\n    .app-mod-section-3-left {\r\n        width: 80%;\r\n        margin: auto;\r\n    }\r\n\r\n    .app-mod-section-3-right {\r\n        width: 90%;\r\n        margin: auto;\r\n\r\n        & img {\r\n            width: 100%;\r\n        }\r\n    }\r\n\r\n    .app-mod-section-3-left p:nth-child(1),\r\n    .app-mod-section-3-left p:nth-child(2),\r\n    .app-mod-section-3-left p:nth-child(3) {\r\n        font-size: 45px;\r\n        text-align: center;\r\n    }\r\n\r\n    .app-mod-section-3-left p:nth-child(4) {\r\n        width: 90%;\r\n        margin: auto;\r\n        font-size: 30px;\r\n        margin-bottom: 2rem;\r\n    }\r\n\r\n    .app-mod-section-4-bottom {\r\n        display: grid;\r\n        grid-template-columns: repeat(1, 1fr);\r\n        gap: 1rem;\r\n\r\n        & div {\r\n            width: 80%;\r\n            margin: auto;\r\n        }\r\n    }\r\n\r\n    .app-mod-section-6 {\r\n        width: 90%;\r\n        margin-top: 0;\r\n    }\r\n\r\n    .app-mod-section-6-top {\r\n        width: 90%;\r\n    }\r\n\r\n    .app-mod-section-6-bottom {\r\n        grid-template-columns: repeat(2, 1fr);\r\n    }\r\n\r\n    .app-mod-section-7>div {\r\n        width: 70%;\r\n    }\r\n\r\n    .app-mod-section-8 {\r\n        width: 90%;\r\n    }\r\n\r\n    .app-mod-section-8-bottom {\r\n        display: grid;\r\n        grid-template-columns: repeat(1, 1fr);\r\n        gap: 2rem;\r\n\r\n        & div {\r\n            width: 80%;\r\n            margin: auto;\r\n\r\n            & img {\r\n                width: 100%;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media screen and (min-width:841px) and (max-width:1450px) {\r\n\r\n    .app-mod-section-1-left p:nth-child(2),\r\n    .app-mod-section-1-left p:nth-child(3) {\r\n        font-size: 51px;\r\n    }\r\n\r\n    .app-mod-section-1-right {\r\n        & img {\r\n            width: 80%;\r\n        }\r\n    }\r\n\r\n    .app-mod-section-3 {\r\n        width: 80%;\r\n    }\r\n\r\n    .app-mod-section-3-left {\r\n        width: 70%;\r\n    }\r\n\r\n    .app-mod-section-3-right {\r\n        width: 45%;\r\n        display: flex;\r\n        align-items: center;\r\n\r\n        & img {\r\n            width: 100%;\r\n        }\r\n    }\r\n\r\n    .app-mod-section-4 {\r\n        margin-bottom: var(--margin-bottom-mobile);\r\n        padding: 1rem 0;\r\n    }\r\n\r\n    .app-mod-section-8-bottom {\r\n\r\n        & p {\r\n            font-size: 22px;\r\n        }\r\n\r\n        & ul {\r\n            font-size: 10px;\r\n        }\r\n    }\r\n\r\n    .app-mod-section-9 {\r\n        width: 90%;\r\n        font-size: 2rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
